import colors from './colors'

export const confirmCode = 'wel@system'
export const defaultLocale = 'th'
export const defaultDirection = 'ltr'

export const localeOptions = [
  {id: 'en', name: 'English', direction: 'ltr'},
  {id: 'th', name: 'Thai', direction: 'ltr'}
]

export const graphQlUrl = process.env.VUE_APP_GRAPHQL_SERVER
export const APIServer = process.env.VUE_APP_API_SERVER
export const appVersion = process.env.VUE_APP_PACKAGE_VERSION

export const secretPublicKey = 'ouj8nv@,boSRV';

export const contactPhone = '062-618-2112';

export const userDefaults = {
  uid: 0,          // From Auth
  displayName: 'John Doe', // From Auth
  about: 'Dessert chocolate cake lemon drops jujubes. Biscuit cupcake ice cream bear claw brownie brownie marshmallow.',
  photoURL: require('@/assets/images/portrait/small/avatar-s-11.jpg'), // From Auth
  status: 'online',
  userRole: 'admin'
}

export const notificationPosition = 'top-right'

export { colors as colors }

export const themeConfig = {
  disableCustomizer : false,       // options[Boolean] : true, false(default)
  disableThemeTour  : false,       // options[Boolean] : true, false(default)
  footerType        : 'static',    // options[String]  : static(default) / sticky / hidden
  hideScrollToTop   : false,       // options[Boolean] : true, false(default)
  mainLayoutType    : 'vertical',  // options[String]  : vertical(default) / horizontal
  navbarColor       : '#fff',      // options[String]  : HEX color / rgb / rgba / Valid HTML Color name - (default: #fff)
  navbarType        : 'floating',  // options[String]  : floating(default) / static / sticky / hidden
  routerTransition  : 'zoom-fade', // options[String]  : zoom-fade / slide-fade / fade-bottom / fade / zoom-out / none(default)
  rtl               : false,       // options[Boolean] : true, false(default)
  sidebarCollapsed  : false,       // options[Boolean] : true, false(default)
  theme             : 'dark',     // options[String]  : 'light'(default), 'dark', 'semi-dark'

  // Not required yet - WIP
  userInfoLocalStorageKey: 'userInfo'

  // NOTE: themeTour will be disabled in screens < 1200. Please refer docs for more info.
}

// import Vue from 'vue'
// import Vuesax from 'vuesax'
// Vue.use(Vuesax, { theme:{ colors }, rtl: themeConfig.rtl })
